/**
 * Format large numbers for compact display.
 *
 * - Under 10,000: comma-separated (e.g. 476, 1,234, 9,999)
 * - 10,000–999,999: K with 1 decimal when needed (e.g. 12.5K, 100K)
 * - 1,000,000+: M with 1 decimal (e.g. 1.2M)
 */
export function formatCount(n: number): string {
    if (n < 10_000) {
        return n.toLocaleString('en-US')
    }

    if (n < 1_000_000) {
        const k = parseFloat((n / 1_000).toFixed(1))
        // Rounding can push 999,999 to 1000K — display as 1M instead
        if (k >= 1000) return '1M'
        return `${k}K`
    }

    const m = n / 1_000_000
    return m % 1 === 0 ? `${m}M` : `${parseFloat(m.toFixed(1))}M`
}
